"use client";

import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { contactSubmission } from "./contact-action";
import { FormSchema, schema } from "./contact-schema";

export function ContactForm() {
  const form = useForm({
    resolver: zodResolver(schema),
  });

  return (
    <div id="usage-pricing-form" className="flex w-full max-w-full flex-col items-center px-2">
      <div className="flex flex-col items-center gap-8">
        <h3 className="mx-2 text-center text-xl leading-tight font-bold tracking-wide sm:text-3xl md:text-4xl lg:text-5xl">
          Get Access to Usage-Based Pricing
        </h3>

        <p className="mx-4 max-w-4xl text-center text-sm tracking-wide text-slate-200 sm:text-lg">
          Tell us about your usage needs, and we will provide access to our flexible, usage-based
          pricing model.
        </p>

        <div className="relative flex w-full max-w-5xl flex-col justify-center gap-4 overflow-hidden rounded-3xl border border-slate-600 bg-slate-900 p-6">
          {form.formState.isSubmitSuccessful && (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-slate-900">
              <CheckCircleIcon className="text-success size-20" />

              <div className="text-lg font-bold">Thank you</div>
              <div className="">Thanks for reaching out. We will get back to you soon.</div>
            </div>
          )}
          <form
            className="flex flex-col gap-4"
            onSubmit={form.handleSubmit(
              async (data) => {
                contactSubmission(data);
              },
              (error) => console.error(error)
            )}
          >
            <label className="form-control w-full">
              <div className="label">
                <span className="label-text">Email</span>
              </div>
              <input
                type="email"
                placeholder="Email"
                className="input w-full border bg-transparent"
                required={true}
                {...form.register("email")}
              />
            </label>
            <button type="submit" className="btn btn-primary">
              Get Access
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
